import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const VerticalArticleCardsCCD: IClientComponentDefinition = {
  name: 'verticalArticleCards',
  load: () => import(/* webpackChunkName: 'verticalArticleCards' */ './index'),
}
